/* ═══════════════════════════════════════════════════════════════════════════
   🎬 reelFollow.js — the reels' small polish rules, ported case for case from
   the phone's services/reelPlayer.ts (gtest/reelpolish.test.mjs runs both over
   the same table, so the two cannot drift).

     ⏩ hold to play faster   REEL_FAST_RATE, REEL_HOLD_MS
     ➕ the follow badge      reelFollowState, REEL_FOLLOW_DONE_MS
   ═══════════════════════════════════════════════════════════════════════════ */

/** The speed a held finger (or mouse button) plays at. */
export const REEL_FAST_RATE = 2;
/** How long a press must rest before it is a hold, not a click. */
export const REEL_HOLD_MS = 350;
/** How long the tick stays after a follow before the badge goes. */
export const REEL_FOLLOW_DONE_MS = 1200;

/**
 * Should the author's avatar carry a "+"? 'add' | 'hidden'.
 *
 * 🟢 A page is followed (`pages/{id}.followers`); a person is added as a friend.
 * 🟥 A page whose state is unknown shows nothing — a "+" that turns out to be
 *    wrong is worse than one a moment late.
 */
export function reelFollowState(o) {
  if (!o || !o.myUid) return 'hidden';
  if (o.pageId) return o.pageFollowed === false ? 'add' : 'hidden';
  if (!o.authorUid || o.authorUid === o.myUid) return 'hidden';
  if (o.isFriend || o.requestSent) return 'hidden';
  return 'add';
}
